import i18n from '@/i18n'
import makeCrudModule from '@/lib/uncrudtable/store/crudfactory'
import apiClient from '@/lib/unlogin/store/apiclient'
import { RESPONSE_LEVEL } from '@/variables'

const modelName = 'Products'
const apiPath = '/products-list/'
const baseCrud = makeCrudModule(apiClient, modelName, apiPath)

const state = {
  ...baseCrud.state,
  settlementTypes: []
}

const getters = {
  ...baseCrud.getters
}

const actions = {
  ...baseCrud.actions,
  getItem ({ commit }, pk) {
    return apiClient
      .get(`${apiPath}${pk}/`)
      .then(response => {
        commit('setCurrentItem', response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  },
  patchItem ({ commit, state }, pk) {
    const alertMessage = {}
    return apiClient
      .patch(`${apiPath}${pk}/`, state.currentItem)
      .then(response => {
        if (response.data.level === RESPONSE_LEVEL.WARNING) {
          alertMessage['level'] = response.data.level
          alertMessage['message'] = response.data.message
        } else {
          commit('setCurrentItem', response.data)
          alertMessage['level'] = RESPONSE_LEVEL.SUCCESS
          alertMessage['message'] = i18n.tc('dialogs.savedNewValues')
        }
        return alertMessage
      })
      .catch(error => {
        if (error.response.data.hasOwnProperty('level')) {
          alertMessage['level'] = error.response.data.level
          alertMessage['message'] = error.response.data.message
        } else {
          alertMessage['level'] = RESPONSE_LEVEL.ERROR
          alertMessage['message'] = i18n.tc('dialogs.errorWhenSaving')
        }
        return alertMessage
      })
  }
}

const mutations = {
  ...baseCrud.mutations
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
